import React from "react";
import { makeStyles } from "@mui/styles";
import { Typography } from "../components/Typography";
import { HeaderMenu } from "../components/Header";
import { Stack } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import jiyoungLim from "../asset/jiyoungLim.png";
import juhangKim from "../asset/juhangKim.png";
import yeseoKim from "../asset/yeseoKim.png";
import jongbokSon from "../asset/jongbokSon.png";
import mincheolKim from "../asset/mincheolKim.png";
import daeyoungJo from "../asset/daeyoungJo.png";
import { Theme } from "@mui/material";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";
import halfCircleBlue from "../asset/half_circle_blue.png";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "0px auto",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "100%",
      minWidth: "auto",
    },
  },
  body: {
    width: "100%",
    height: "100%",
    minHeight: 1050,
    justifyContent: "center",
    alignSelf: "center",
    display: "flex",
    flexDirection: "column",
    borderTop: "1px solid #0000003b",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "flex",
      flexDirection: "column",
      width: "auto",
      height: "100%",
      margin: "12px 20px",
      borderTop: "none",
    },
  },
  topTextBox: {
    display: "flex",
    flexDirection: "column",
    width: 600,
    position: "relative",
    alignSelf: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      width: "100%",
      justifyContent: "center",
      margin: "20px 0px",
    },
  },
  subTitleBox: {
    display: "flex",
    position: "relative",
    alignSelf: "center",
    marginTop: 30,
    marginBottom: 90,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      width: "100%",
      justifyContent: "center",
      margin: "15px 0px 0px 0px",
    },
  },
  top_text: {
    position: "relative",
    display: "flex",
    justifyContent: "left",
    color: "#204FA1",
    maxWidth: 1290,
    fontSize: 18,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: 18,
      marginTop: 0,
      marginLeft: 20,
      justifyContent: "flex-start",
    },
  },
  subTitle: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    color: "#EB4FE5",
    fontSize: 16,
  },
  container: {
    position: "relative",
    display: "flex",
    background: "#fdf5fd",
    height: 130,
    flexDirection: "column",
    justifyContent: "center",
    margin: "30px 0px 150px 0px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      flexDirection: "column",
      height: "100%",
      marginBottom: 50,
      padding: "20px 0px",
    },
  },
  teamBox1: {
    position: "relative",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      padding: 0,
      minWidth: 320,
    },
  },
  teamBox2: {
    minWidth: 460,
    position: "relative",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      minWidth: 320,
    },
  },
  teamTag: {
    width: "121px",
    color: "#fff",
    backgroundColor: "#EB4FE5",
    position: "relative",
    borderRadius: "20px",
    textAlign: "center",
    display: "inline-block",
    padding: "3px 20px",
    marginBottom: "50px",
    right: 110,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 0,
    },
  },
  team1: {
    // display: "grid",
    display: "flex",
    flexDirection: "row",
    position: "relative",
    justifyContent: "center",

    [theme.breakpoints.down(MobileWeb.mobile)]: {
      flexDirection: "column",
      alignItems: "center",
    },
  },
  team2: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    position: "relative",

    [theme.breakpoints.down(MobileWeb.mobile)]: {
      flexDirection: "column",
      alignItems: "center",
    },
  },
  avatarCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    textAlign: "center",
    wordBreak: "keep-all",
    width: 138,
    height: 246,
    borderRadius: 20,
    padding: "20px 15px",
    backgroundColor: "#fff",
    boxShadow: "2px 2px 5px 2px #FDF5FD",
    marginRight: 50,
    "&:last-child": {
      marginRight: 0,
    },
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      marginRight: 0,
      marginBottom: 20,
      "&:last-child": {
        marginBottom: 0,
      },
    },
  },
  halfCircleBlue: {
    position: "relative",
    bottom: 5,
    right: 30,
    width: 65,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 0,
      bottom: 5,
      marginLeft: 0,
    },
  },
}));

export const TeamPage = () => {
  const classes = useStyles();
  // const Item = styled(Paper)(({ theme }) => ({
  //   ...theme.typography.body2,
  //   padding: theme.spacing(1),
  //   textAlign: "center",
  //   color: theme.palette.text.secondary,
  // }));

  return (
    <div className={classes.root}>
      <HeaderMenu />
      <div className={classes.body}>
        <div className={classes.topTextBox}>
          <img
            src={halfCircleBlue}
            alt="blueHalfCircle"
            className={classes.halfCircleBlue}
          />
          <Typography variant="H3" className={classes.top_text}>
            TEAM
          </Typography>
        </div>
        <div className={classes.subTitleBox}>
          {/* 팀 타이틀 수정 */}
          {/* 관호관리 개발팀 >> 콘텐츠 개발팀 */}
          <Typography variant="teamSubTitle" className={classes.subTitle}>
            콘텐츠 개발팀
          </Typography>
        </div>
        <div className={classes.container}>
          <div className={classes.teamBox1}>
            {/* <div className={classes.pinkLineTop} />
            <div className={classes.PinkLineBottom} />
            <div className={classes.PinkLineBottom} /> */}
            {/* 간호관리 개발팀 */}
            <div className={classes.team1}>
              <div className={classes.avatarCard}>
                <div>
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ marginBottom: "15px" }}
                  >
                    <Avatar
                      alt="간호관리 개발팀 대표"
                      src={jiyoungLim}
                      sx={{
                        width: 80,
                        height: 80,
                      }}
                    />
                  </Stack>
                </div>
                <div>
                  <Typography variant="Name">임지영</Typography>
                  <br />
                  <Typography variant="Caption1">대표</Typography>
                </div>
                <div>
                  <Typography variant="NameContent">
                    간호관리 전공 교수
                    <br /> 재무,원가,창업 등<br />
                    온라인 교육 프로그램 다수 개발
                  </Typography>
                </div>
              </div>

              <div className={classes.avatarCard}>
                <div>
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ marginBottom: "15px" }}
                  >
                    <Avatar
                      alt="간호관리 개발팀 개발 책임"
                      src={juhangKim}
                      sx={{
                        width: 80,
                        height: 80,
                      }}
                    />
                  </Stack>
                </div>
                <div>
                  <Typography variant="Name">김주행</Typography>
                  <br />
                  <Typography variant="Caption1">개발 책임</Typography>
                </div>
                <div>
                  <Typography variant="NameContent">
                    간호관리 전공 교수
                    <br /> 원가관리 P개발
                  </Typography>
                </div>
              </div>

              <div className={classes.avatarCard}>
                <div>
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ marginBottom: "15px" }}
                  >
                    <Avatar
                      alt="간호관리 개발팀 콘텐츠 개발"
                      src={yeseoKim}
                      sx={{ width: 80, height: 80 }}
                    />
                  </Stack>
                </div>
                <div>
                  <Typography variant="Name">김예서</Typography>
                  <br />
                  <Typography variant="Caption1">콘텐츠 개발</Typography>
                </div>
                <div>
                  <Typography variant="NameContent">
                    간호사
                    <br /> 정신과 병동, 실습지도
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 간호관리 개발팀 */}
        {/* 기술개발팀 */}
        <div className={classes.subTitleBox}>
          <Typography variant="teamSubTitle" className={classes.subTitle}>
            기술 개발팀
          </Typography>
        </div>
        <div className={classes.container}>
          <div className={classes.teamBox2} style={{}}>
            <div className={classes.team2}>
              <div className={classes.avatarCard}>
                <div>
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ marginBottom: "15px" }}
                  >
                    <Avatar
                      alt="기술개발팀대표"
                      src={jongbokSon}
                      sx={{
                        width: 80,
                        height: 80,
                      }}
                    />
                  </Stack>
                </div>
                <div>
                  <Typography variant="Name">손종복</Typography>
                  <br />
                  <Typography variant="Caption1">대표</Typography>
                </div>
                <div>
                  <Typography variant="NameContent">
                    커뮤니케이션 기획
                    <br /> 미장센, 맥심, 필립스 등
                  </Typography>
                </div>
              </div>

              <div className={classes.avatarCard}>
                <div>
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ marginBottom: "15px" }}
                  >
                    <Avatar
                      alt="프로그램개발"
                      src={mincheolKim}
                      sx={{
                        width: 80,
                        height: 80,
                      }}
                    />
                  </Stack>
                </div>
                <div>
                  <Typography variant="Name">김민철</Typography>
                  <br />
                  <Typography variant="Caption1">프로그램 개발</Typography>
                </div>
                <div>
                  <Typography variant="NameContent">정보통신공학</Typography>
                </div>
              </div>

              <div className={classes.avatarCard}>
                <div>
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ marginBottom: "15px" }}
                  >
                    <Avatar
                      alt="VR 영상 개발"
                      src={daeyoungJo}
                      sx={{ width: 80, height: 80 }}
                    />
                  </Stack>
                </div>
                <div>
                  <Typography variant="Name">조대영</Typography>
                  <br />
                  <Typography variant="Caption1">VR 영상 개발</Typography>
                </div>
                <div>
                  <Typography variant="NameContent">
                    한국 IT 직업전문학교
                    <br /> 초빙교수
                    <br />
                    롤코레이싱 등 VR기반
                    <br />
                    게임 개발
                  </Typography>
                </div>
              </div>

              {/* <div className={classes.teamTag}>기술 개발팀</div>
              <Stack direction="row" spacing={2} sx={{ marginBottom: "50px" }}>
                <Avatar
                  alt="기술개발팀 대표"
                  src={jongbokSon}
                  sx={{ width: 120, height: 120, border: "1px solid #EB5FE5" }}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignSelf: "center",
                  }}
                >
                  <Typography
                    variant="Name"
                    style={{ color: "#EB4FE5", marginBottom: 5 }}
                  >
                    손종복
                    <Typography
                      variant="Caption1"
                      style={{ color: "#000", marginLeft: "5px" }}
                    >
                      / 대표
                    </Typography>
                  </Typography>
                  <Typography variant="NameContent">
                    커뮤니케이션 기획
                    <br />
                    미장센, 맥심, 필립스 등
                  </Typography>
                </div>
              </Stack>

              <Stack direction="row" spacing={2} sx={{ marginBottom: "50px" }}>
                <Avatar
                  alt="기술개발팀 프로그램 개발"
                  src={mincheolKim}
                  sx={{ width: 120, height: 120, border: "1px solid #EB5FE5" }}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignSelf: "center",
                  }}
                >
                  <Typography
                    variant="Name"
                    style={{ color: "#EB4FE5", marginBottom: 5 }}
                  >
                    김민철
                    <Typography
                      variant="Caption1"
                      style={{ color: "#000", marginLeft: "5px" }}
                    >
                      / 프로그램 개발
                    </Typography>
                  </Typography>
                  <Typography variant="NameContent">정보통신공학</Typography>
                </div>
              </Stack>
              <Stack direction="row" spacing={2}>
                <Avatar
                  alt="기술개발팀 VR 영상 개발"
                  src={daeyoungJo}
                  sx={{ width: 120, height: 120, border: "1px solid #EB5FE5" }}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignSelf: "center",
                  }}
                >
                  <Typography
                    variant="Name"
                    style={{ color: "#EB4FE5", marginBottom: 5 }}
                  >
                    조대영
                    <Typography
                      variant="Caption1"
                      style={{ color: "#000", marginLeft: "5px" }}
                    >
                      / VR 영상 개발
                    </Typography>
                  </Typography>
                  <Typography variant="NameContent">
                    한국 IT 직업전문학교
                    <br /> 초빙교수
                    <br />
                    롤코레이싱 등 VR기반 게임 개발
                  </Typography>
                </div>
              </Stack>
            </div> */}
              {/* 기술개발팀 */}
            </div>
          </div>
          <div></div>
        </div>
      </div>
      <Footer />
      <div style={{ display: "flex" }}>
        <MobileFooter />
      </div>
    </div>
  );
};
